import { render, staticRenderFns } from "./IconEditionItem.vue?vue&type=template&id=671b73ba&scoped=true&"
import script from "./IconEditionItem.vue?vue&type=script&lang=js&"
export * from "./IconEditionItem.vue?vue&type=script&lang=js&"
import style0 from "./IconEditionItem.vue?vue&type=style&index=0&id=671b73ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671b73ba",
  null
  
)

export default component.exports